import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import SearchCompany from './SearchCompany'
import debounce from "lodash/debounce";
import '../../css/empresa_uno/history-products.css';
import Paper from '@mui/material/Paper';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, FormControl, Typography, } from '@mui/material';
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import CallApi from '../../data/CallApi';
import { toast } from 'react-toastify';
import { SelectBranchs, useProovedorData } from '../../components';
import { ImagenesGlobal } from '../../components/global/ImagenesGlobal';

import DeleteIcon from '@mui/icons-material/Delete';
import RestorePageIcon from '@mui/icons-material/RestorePage';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import RestoreIcon from '@mui/icons-material/Restore';

import { ModalViewProductEmpresa } from '../../components/empresa_uno_comp/Modal_view_product_empresa';
import { ModalHistory } from '../../components/empresa_uno_comp/ModalHistory';
import { Preloader } from '../../components/Preloader';
import ButtonLoader from '../../components/global/ButtonLoader';
import TableMobile from '../../components/empresa/TableMobile';

export const ProductHistory = ({
  sucursal_selected,
  obj_sucursal,
  companyID = 0,
  convertPrice = (() => { }),
}) => {
  const postBranch = (obj_sucursal ?? []).findIndex((obj) => obj?.key_branch == sucursal_selected);
  const tableSelected = `product_${companyID}#${postBranch}`;

  const listProducts = useRef([]);

  const [currentSize, setCurrentSize] = useState(window.innerWidth);

  const [productsFiltered, setProductsFiltered] = useState([]);
  const [productSelected, setProductSelected] = useState({});
  const [listHistorySelected, setListHistorySelected] = useState([]);
  const [stateLoader, setStateLoader] = useState({
    list: false,
    pHistory: false,
    pDelete: false,
    pSaving: false
  });

  const { loadImageS, dbData } = useProovedorData() ?? [];

  const debouncedSearch = useCallback(
    debounce((item) => {
      const textSearch = String(item.target.value).toLowerCase();
      if (textSearch.trim() == '') return setProductsFiltered(listProducts?.current);

      const results = listProducts.current.filter((obj) => String(obj?.name).toLowerCase().includes(textSearch) || String(obj?.code).toLowerCase().includes(textSearch));
      setProductsFiltered(results);
    }, 700),
    [sucursal_selected]
  );

  const handleStateProduct = async (product) => {
    if (typeof product != 'object') return toast.info("producto invalido");
    try {
      setStateLoader((current_obj) => ({
        ...current_obj,
        pDelete: true
      }));

      const itsDelete = product?.state == 'active';

      const handleState = await CallApi({
        url: `api/company/product/${itsDelete ? 'delete' : 'recover'}?key_branch=${sucursal_selected}`,
        method: itsDelete ? 'delete' : 'put',
        body: {
          key_product: product?.key_product,
        }
      });

      if (!handleState || handleState?.code == 400) throw new Error('error al modificar producto');
      // await new Promise((resolve) => setTimeout(resolve, 3000));

      setProductsFiltered((current_list) =>
        current_list.map((obj) => {
          if (obj.key_product === product.key_product) {
            return {
              ...obj,
              state: obj.state === 'inactive' ? 'active' : 'inactive'
            };
          }
          return obj;
        })
      );

      listProducts.current = listProducts.current.map((obj) => {
        if (obj.key_product === product.key_product) {
          return {
            ...obj,
            state: obj.state === 'inactive' ? 'active' : 'inactive'
          };
        }
        return obj;
      });

      await dbData.delete('expiration', tableSelected);
    } catch (error) {
      console.error(error);
    } finally {
      setStateLoader((current_obj) => ({
        ...current_obj,
        pDelete: false
      }));
    }
  }

  const columns: GridColDef[] = [
    {
      field: 'images',
      headerName: 'Foto',
      flex: 1,
      renderCell: (params) => {
        if (!params?.row) return null;
        return (
          <div style={{ width: "80px", height: "80px", margin: "5px", aspectRatio: '1/1', overflow: 'hidden', borderRadius: '10px' }}>
            <ImagenesGlobal
              url={params.row.images[0] ?? 'image_none'}
              alt={params.row?.name}
              style={{ width: "100%", height: "100%", objectFit: 'cover', objectPosition: 'center' }}
              key={params.row.key_product ?? 'image_none'}
              loadImageS={loadImageS}
              type={'picture'}
            />
          </div>
        );
      },
    },
    { field: 'code', headerName: 'Codigo', flex: 1, sortable: false },
    { field: 'name', headerName: 'Nombre', flex: 2, sortable: true, },
    { field: 'last_update', headerName: 'Fecha', flex: 1 },
    { field: 'stock', headerName: 'Cantidad', flex: 1 },
    { field: 'price', headerName: 'Precio', flex: 1, valueGetter: (value, row) => convertPrice(row.price) },
    {
      field: '',
      headerName: 'Accion',
      width: 90,
      renderCell: (params) => {
        if (!params?.row) return null;
        return returnActionButtons(params);
      },
    },

    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // {
    //   field: 'age',
    //   headerName: 'Age',
    //   type: 'number',
    //   flex: 1
    // },
    // {
    //   field: 'fullName',
    //   headerName: 'Full name',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   flex: 3,
    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // },
  ];

  const returnActionButtons = (obj) => {
    const params = obj?.row ? obj.row : obj;

    return (
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '100%', height: '100%' }}>

        <ButtonLoader
          colorProgress='var(--theme-company)'
          state_progress={stateLoader.pHistory}
          className='default-buttons'
          custom_styles={{ height: 'min-content' }}
          onClick={getProductHistory} parameters={params}
        >
          <RestorePageIcon style={{ fontSize: '20px', color: 'var(--pc-gris)' }} />
        </ButtonLoader>

        <ButtonLoader
          colorProgress='var(--theme-company)'
          state_progress={stateLoader.pDelete}
          className='default-buttons'
          custom_styles={{ height: 'min-content' }}
          onClick={handleStateProduct} parameters={params}
        >
          {
            params?.state == 'active' ? (
              <DeleteIcon style={{ fontSize: '20px', color: '#FF0000' }} />
            ) : (
              <RestoreIcon style={{ fontSize: '22px', color: 'var(--theme-company)' }} />
            )
          }
        </ButtonLoader>
      </div>
    )
  }

  const paginationModel = { page: 0, pageSize: 5 };

  async function listHistory() {
    setStateLoader((current_obj) => ({
      ...current_obj,
      list: true
    }));

    const resultListHistory = await CallApi({
      url: `api/company/product/history?key_branch=${sucursal_selected}`
    });

    if (!resultListHistory) return;

    listProducts.current = resultListHistory;
    setProductsFiltered(resultListHistory);

    setStateLoader((current_obj) => ({
      ...current_obj,
      list: false
    }));
  }

  useEffect(() => {
    const handleResize = () => {
      setCurrentSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup function para quitar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    listHistory();
  }, [sucursal_selected]);

  const dataWithIds = productsFiltered.map((obj, index) => ({
    ...obj,
    id: obj?.key_product ?? index
  }));

  async function getProductHistory(obj) {
    setStateLoader((current_obj) => ({
      ...current_obj,
      pHistory: true
    }));

    const key = obj?.key_product;

    const resultHistory = await CallApi({
      url: `api/company/product/history/${key}?key_branch=${sucursal_selected}`
    });

    let newSelected = [...resultHistory].map((obj_param) => ({ ...obj_param, key_product: key, state: obj?.state ?? 'inactive' }));

    if (resultHistory && Array.from(resultHistory).length > 0) setListHistorySelected(newSelected);
    else toast.info('Producto sin cambios registrados');

    setStateLoader((current_obj) => ({
      ...current_obj,
      pHistory: false
    }));
  }

  async function updateProduct(obj_updated) {
    listProducts.current = listProducts.current.map((obj) => obj?.key_product != obj_updated?.key_product ? obj : obj_updated);
    setProductsFiltered((current_list) => current_list.map((obj) => obj?.key_product != obj_updated?.key_product ? obj : obj_updated));

    if (!dbData) return console.error("No fue posible conectarse a la bd");

    await dbData.delete('expiration', tableSelected);
  }

  const handleView = (row) => {
    let product_selected = null;
    if (row?.other) product_selected = row.authCode;

    setProductSelected(product_selected ?? row);
  };

  return (
    <>
      <div className='panel-history'>
        <div className="product-reverse">
          <h2>Historial</h2>

          <FormControl size="small" sx={{ minWidth: 120, maxWidth: 200 }}>
            <SelectBranchs />
          </FormControl>
        </div>

        <SearchCompany theme={'var(--theme-company)'} setValor={debouncedSearch} placeholder="Producto" />
        <span></span>
      </div>

      {
        currentSize > 480 ? (
          <Paper sx={{ height: '70vh', width: '100%', marginTop: '10px' }}>
            {
              stateLoader.list ? <Preloader /> : (
                <DataGrid
                  rows={dataWithIds}
                  rowHeight={90}
                  columns={columns}
                  initialState={{ pagination: { paginationModel } }}
                  sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeader": {
                      backgroundColor: 'var(--theme-company)',
                      color: "white",
                      fontWeight: "bold",
                      width: '100%'
                    },

                    "& .MuiDataGrid-footerContainer": {
                      justifyContent: "flex-end",
                      alignItems: "center !important",
                    },

                    "& .MuiTablePagination-toolbar": {
                      alignItems: "center !important",
                    },

                    "& .MuiTablePagination-selectLabel": {
                      marginBottom: 0,
                    },

                    "& .MuiTablePagination-displayedRows": {
                      marginBottom: 0,
                    },
                  }}
                  pageSizeOptions={[5, 10, 25, 50]} ñ
                  localeText={{
                    MuiTablePagination: {
                      labelRowsPerPage: "Filas por pagina:",
                      labelDisplayedRows: ({ from, to, count }) =>
                        `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
                    },
                  }}
                  rowSelection={false}
                  slots={{
                    noRowsOverlay: () => (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}>
                        <VisibilityOffRoundedIcon
                          sx={{ fontSize: 40, color: "text.secondary", mb: 1 }}
                        />
                        <Typography variant="h6" color="textSecondary">
                          No hay productos disponibles
                        </Typography>
                      </Box>
                    ),
                  }}
                  onRowClick={(data) => setProductSelected(data?.row)}
                />
              )
            }

          </Paper>
        ) : (
          <TableMobile
            loadImageS={loadImageS}
            itsCompany={true}
            filteredData={(productsFiltered ?? []).map((obj) => ({
              img: obj?.images[0],
              title: obj?.name,
              other: 'CÓDIGO: ' + obj?.code,
              texto: convertPrice(obj?.price),
              authCode: obj
            }))}
            profile={true}
            type="picture"
            functionEspecial={returnActionButtons}
            mode="reportes"
            showDetail={handleView}
          />
        )
      }


      <ModalViewProductEmpresa
        onClose={() => setProductSelected(({}))}
        product={productSelected}
        isPrivileged={false}
        loadImageS={loadImageS}
        convertPrice={convertPrice}
      />

      <ModalHistory
        listHistory={listHistorySelected}
        closeModalHistory={() => setListHistorySelected([])}
        updateProduct={updateProduct}
        current_branch={sucursal_selected}
      />
    </>
  )
}